import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { colors } from '../lib/theme';

export default function SecurityPage() {
  return (
    <div className="min-h-screen text-slate-100" style={{ backgroundColor: colors.bgPrimary }}>
      <header
        className="sticky top-0 z-30 w-full backdrop-blur-sm"
        style={{
          borderBottom: `1px solid ${colors.border}`,
          backgroundColor: `${colors.bgSecondary}80`,
        }}
      >
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 h-16 flex items-center gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 text-sm hover:opacity-80 transition-opacity"
            style={{ color: colors.textSecondary }}
          >
            <ArrowLeft className="h-4 w-4" />
            Back to screener
          </Link>
          <span className="font-semibold tracking-tight" style={{ color: colors.textPrimary }}>
            Security
          </span>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-12 space-y-8">
        <section>
          <h1 className="text-3xl font-bold" style={{ color: colors.textPrimary }}>
            Security &amp; privacy
          </h1>
          <p className="mt-4 leading-relaxed" style={{ color: colors.textSecondary }}>
            How EthicCheck handles data, API access, and secrets for the public MVP screener.
          </p>
        </section>

        <section className="space-y-4">
          <Block title="What we store">
            Screening requests are processed in memory — we do not save your portfolio as an account
            feature. Waitlist emails are stored if you opt in. Audit records may log symbol, verdict,
            and reasons without user identity.
          </Block>
          <Block title="Rate limiting">
            The API limits requests per IP (100 per 15 minutes globally). Screening accepts up to 500
            ticker symbols per request with format validation.
          </Block>
          <Block title="Secrets">
            Database URLs and API keys live in server environment variables only — never in the
            browser. Production uses HTTPS on Railway (API and frontend).
          </Block>
          <Block title="Error monitoring">
            When configured, unhandled server errors may be reported to Sentry for reliability. No
            portfolio contents are intentionally sent to third-party analytics.
          </Block>
        </section>

        <p className="text-sm" style={{ color: colors.textMuted }}>
          See also <Link to="/privacy" className="underline hover:opacity-80">Privacy</Link> and{' '}
          <Link to="/disclaimer" className="underline hover:opacity-80">Disclaimer</Link>.
        </p>
      </main>
    </div>
  );
}

function Block({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div
      className="rounded-xl p-5"
      style={{
        border: `1px solid ${colors.border}`,
        backgroundColor: colors.bgSecondary,
      }}
    >
      <h2 className="font-semibold" style={{ color: colors.textPrimary }}>{title}</h2>
      <p className="mt-2 text-sm leading-relaxed" style={{ color: colors.textSecondary }}>{children}</p>
    </div>
  );
}
